import React from 'react'

function ChatIcon(props) {
  return (
    <svg
      width='71'
      height='42'
      viewBox='0 0 71 42'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M27.1752 20.8572C27.1752 10.0259 28.9804 8.2207 48.8377 8.2207C68.695 8.2207 70.5002 10.748 70.5002 20.8572C70.5002 30.9663 64.5923 33.4936 54.7457 33.4936V40.7145L44.8991 33.4936C27.1752 33.4936 27.1752 31.6884 27.1752 20.8572Z'
        fill='#003D87'
        stroke='white'
        strokeWidth='0.5'
      />
      <path
        d='M44.325 13.6365C44.325 2.80521 42.5198 1 22.6625 1C2.80521 1 1 3.52729 1 13.6365C1 23.7456 2.80521 26.2729 22.6625 26.2729V33.4938L31.6885 26.2729C42.5198 26.2729 44.325 24.4677 44.325 13.6365Z'
        fill='#003D87'
        stroke='white'
        strokeWidth='0.5'
      />
    </svg>
  )
}

export default ChatIcon
